import styled from "@emotion/styled"
import { Grid, Typography } from "@mui/material"
import * as api from "api"
import { ServiceCenterApplicationType } from "api"
import { memo, useState } from "react"
import Shared from "theme/shared"
import ServiceCenterContactDialog from "./dialogs/ServiceCenterContactDialog"

const Styled = {
  Wrapper: styled.div`
    padding: 0 15px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      padding-top: 30px;
    }
  `,
  NameWrap: styled.div`
    display: flex;
    padding: 0;
    padding-bottom: 25px;
  `,
  Logo: styled.img`
    width: 45px;
    height: 54px;
    margin-inline-end: 15px;
    object-fit: contain;
    border-radius: 5px;
    border: 1px solid ${(p) => p.theme.colors.silver};
    display: block;
    font-size: 10px;
  `,
  Title: styled(Typography)`
    margin: 0;
  `,
  Subtitle: styled(Typography)<{ component: string }>`
    margin: 0;
  `,
  ActionButtons: styled(Grid)`
    display: flex;
    gap: 15px;
    margin-bottom: 25px;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin-inline-start: 60px;
    }
  `,
  ContactButton: styled(Shared.Button)`
    height: 35px;
  `,
}

type HeadlineProps = {
  serviceCenter: api.SingleServiceCenter & api.ServiceCenter
}

const Headline = ({ serviceCenter }: HeadlineProps) => {
  const [contactDialogType, setContactDialogType] =
    useState<ServiceCenterApplicationType | null>(null)

  return (
    <Styled.Wrapper>
      <Styled.NameWrap>
        {serviceCenter?.logo?.imageUrl && (
          <Styled.Logo
            src={serviceCenter?.logo?.imageUrl}
            alt={serviceCenter.name}
          />
        )}
        <div>
          <Styled.Title variant="h1">{serviceCenter.name}</Styled.Title>

          <Styled.Subtitle variant="h2" component="p">
            {serviceCenter.city}
          </Styled.Subtitle>
        </div>
      </Styled.NameWrap>

      <Styled.ActionButtons>
        <Styled.ContactButton
          variant="contained"
          onClick={() => setContactDialogType("Treatment")}
        >
          תיאום טיפול
        </Styled.ContactButton>

        <Styled.ContactButton
          variant="outlined"
          onClick={() => setContactDialogType("Contact")}
        >
          צור קשר
        </Styled.ContactButton>
      </Styled.ActionButtons>
      <ServiceCenterContactDialog
        serviceCenter={serviceCenter}
        type={contactDialogType}
        onClose={() => setContactDialogType(null)}
      />
    </Styled.Wrapper>
  )
}

export default memo(Headline)
